export const PERCENTAGE_BREAKDOWN_PARTS = [
  'container',
  'bar',
  'barSegment',
  'barTotal',
  'tooltip',
  'tooltipItem',
  'tooltipItemDot',
  'tooltipItemLabel',
  'tooltipItemValue',
  'tooltipMessage',
] as const;
